import { render, staticRenderFns } from "./ChartEx.vue?vue&type=template&id=1afb92b3&scoped=true"
import script from "./ChartEx.vue?vue&type=script&lang=js"
export * from "./ChartEx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb92b3",
  null
  
)

export default component.exports